import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { LLMType } from 'models/enums/LLMType';

interface Dictionary<T> {
  [Key: string]: T;
};

export type AllowedRagCategory = 'Qualifications' | 'Proposals';

export interface ILLMConfig {
  llmType: string;
  rag: boolean;
  citate: boolean;
  sourceRagCategories?: AllowedRagCategory[];
  anthropic?: Dictionary<string> | null;
  openai?: Dictionary<string> | null;
};

interface ILLMConfigState {
  config: {
    [key: string]: ILLMConfig;
  };
};

const initialState: ILLMConfigState = {
  config: {}
};

const DEFAULT_CONFIG: ILLMConfig = {
  llmType: LLMType.CLAUDE,
  rag: false,
  citate: false,
  sourceRagCategories: []
};

export const currentLLMConfigSlice = createSlice({
  name: 'currentLLMConfig',
  initialState,
  reducers: {
    setNewConfigForKey: (state, action: PayloadAction<{ key: string; config: Partial<ILLMConfig> }>) => {
      const { key, config } = action.payload;
      const prev: ILLMConfig = state.config[key] ?? DEFAULT_CONFIG;

      const mergedCategories = (config.sourceRagCategories ?? prev.sourceRagCategories ?? []).filter(
        (c: AllowedRagCategory) => c === 'Qualifications' || c === 'Proposals'
      );
      const uniqueCategories = Array.from(new Set(mergedCategories));

      state.config[key] = {
        ...prev,
        ...config,
        sourceRagCategories: uniqueCategories
      };
    }
  }
});

export const { setNewConfigForKey } = currentLLMConfigSlice.actions;

export default currentLLMConfigSlice.reducer;